import ReportLayout from './layouts/reportLayout.vue'

/*------------------Report Generator----------------*/
import QuarterlyProgressReport from './components/reportGenerate/pdf/quarterlyProgressReport.vue'
import MonthlyProgressReport from './components/reportGenerate/pdf/monthlyProgressReport.vue'
import ProcurementReport from './components/reportGenerate/pdf/procurementReport.vue'
import ProjectCashForStatementReport from './components/reportGenerate/pdf/projectCashForStatementReport.vue'

import ContractImpReport from './components/reportGenerate/reportsB/ContractImplementationReport.vue'
import DesignatedActStatement from './components/reportGenerate/reportsB/DesignatedAccountActivityStatement.vue'
import ProjectFinancialStatement from './components/reportGenerate/reportsB/ProjectFinancialStatement.vue'
import ProjectSourcesUseFunds from './components/reportGenerate/reportsB/ProjectSourcesUseFunds.vue'
import SummaryGobContribution from './components/reportGenerate/reportsB/SummaryGobContribution.vue'
/*------------------/Report Generator----------------*/

/*------------------Report Generator By Sabir----------------*/
import physInvFxAssets from './components/reportGenerate/pdf/phys_inv_fx_assets.vue'
import satmentFxAsset from './components/reportGenerate/pdf/satment_fx_asset.vue'
import bankAccountInformation from './components/reportGenerate/pdf/bank_account_information.vue'
import dosaBankRecon from './components/reportGenerate/pdf/dosa_bank_recon.vue'
import designatedAccountExpenseContract2B from './components/reportGenerate/pdf/designated_account_expense_contract2B.vue'
import designatedAccountExpenseContract from './components/reportGenerate/pdf/designated_account_expense_contract.vue'
import usesFundProjComponent from './components/reportGenerate/pdf/uses_fund_proj_component.vue'
/*------------------/Report Generator By Sabir----------------*/

/*------------------Report Generator by majeed----------------*/
import TrainingInformationReport from './components/reportGenerate/pdf/trainingInformationReport'
import TrainingInformationDetailReport from './components/reportGenerate/pdf/trainingInformationDetailReport'
import ProcurementPlanReport from './components/reportGenerate/pdf/procurementPlanReport'
/*------------------/Report Generator by majeed----------------*/


export default [
    {
        path: '/generate',
        component: ReportLayout,
        children: [

            /*-----------------/Bulbul---------------*/
            {
                path: 'quarterly-pro-report',
                component: QuarterlyProgressReport
            },
            {
                path: 'monthly-progress-report',
                component: MonthlyProgressReport
            },
            {
                path: 'procurement-report',
                component: ProcurementReport
            },
            {
                path: 'project-cash-report',
                component: ProjectCashForStatementReport
            },
            {
                path: 'contract-imp-report',
                component: ContractImpReport
            },
            {
                path: 'designated-act-statement',
                component: DesignatedActStatement
            },
            {
                path: 'project-financial-statement',
                component: ProjectFinancialStatement
            },
            {
                path: 'project-sources-use-funds',
                component: ProjectSourcesUseFunds
            },
            {
                path: 'summary-gob-contribution',
                component: SummaryGobContribution
            },

            /*-----------------/Bulbul---------------*/

            /*-----------------Majeed---------------*/
            {
                path: 'training-info-report',
                component: TrainingInformationReport
            },
            {
                path: 'training-info-detail-report',
                component: TrainingInformationDetailReport
            },
            {
                path: 'procurement-plan-report',
                component: ProcurementPlanReport
            },
            /*-----------------/Majeed---------------*/

            /*----------------- Sabir ---------------*/
            {
                path: 'phys-inv-fx-assets',
                component: physInvFxAssets
            },
            {
                path: 'satment-fx-asset',
                component: satmentFxAsset
            },
            {
                path: 'bank-account-information',
                component: bankAccountInformation
            },
            {
                path: 'dosa-bank-recon',
                component: dosaBankRecon
            },
            {
                path: 'designated-account-expense-contract2B',
                component: designatedAccountExpenseContract2B
            },
            {
                path: 'designated-account-expense-contract',
                component: designatedAccountExpenseContract
            },
            {
                path: 'uses-fund-proj-component',
                component: usesFundProjComponent
            },
            /*----------------- /Sabir ---------------*/
        ]
    },
]




// WEBPACK FOOTER //
// ./src/reportGeneratorRouter.js